import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import SearchPersonSipo, {
  SearchPersonSipoProps,
} from 'shell/components/shared/search-sipo-person';
import { createSearchParams, generatePath, useNavigate } from 'react-router-dom';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { PersonalDataVM } from 'shell/view-models/personal-data';
import { SearchPersonCivilUnionNonResidentCrumbs } from 'mutation/constants/registration-civil-union-non-resident-crumbs';

interface PersonsPageCivilUnionNonResidentProps extends SearchPersonSipoProps {
  addedTitle?: string;
  goBackUrl?: string;
  onSuccess?: (item: PersonalDataVM) => void;
  onSipoPersonSelected?: (item?: PersonalDataVM) => void;
  redirectUrl?: string;
  editSipoUrl?: string;
  isWithoutBreadcrumb?: boolean;
}

const PersonsPageCivilUnionNonResident = ({
  addedTitle = 'Registrazione Unione Civile Non Residenti',
  goBackUrl,
  onSuccess,
  onSipoPersonSelected,
  isWithoutBreadcrumb,
  redirectUrl = '/mutazioni/persona/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
  editSipoUrl = '/mutazioni/persona/unione-civile/non-residenti/persona-sipo',
  initialValues,
}: PersonsPageCivilUnionNonResidentProps): React.ReactElement => {
  const navigate = useNavigate();

  const handleOnSuccess = useCallback(
    (item) => {
      if (onSuccess) {
        onSuccess(item);
      } else {
        navigate({
          pathname: generatePath(redirectUrl || '', {
            idIntestatario: item?.generality?.municipalityIdentifier || '0',
            idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '0',
          }),
          search: `?${createSearchParams({
            codiceFiscale: item?.fiscalCode || '',
            idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '',
          })}`,
        });
      }
    },
    [onSuccess, redirectUrl]
  );

  const handleOnSipoSelected = useCallback(
    (item) => {
      if (onSipoPersonSelected) {
        onSipoPersonSelected(item);
      } else {
        navigate(
          {
            pathname: generatePath(editSipoUrl || ''),
            search: `?${createSearchParams({
              idIntestatario:
                item?.idSchedaSoggetto || item?.generality?.municipalityIdentifier || '',
              idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '',
              codiceFiscale: item?.fiscalCode || '',
            })}`,
          },
          {
            state: item,
          }
        );
      }
    },
    [onSipoPersonSelected, editSipoUrl]
  );

  return (
    <Fragment>
      {isWithoutBreadcrumb ? undefined : (
        <Breadcrumbs items={SearchPersonCivilUnionNonResidentCrumbs} />
      )}
      <SearchPersonSipo
        url={`${__PERSON_API_URL__}/non-residenti/ricerca-intestatario-unione-civile`}
        addedTitle={addedTitle}
        goBackUrl={goBackUrl}
        onSuccess={handleOnSuccess}
        onSipoPersonSelected={handleOnSipoSelected}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

PersonsPageCivilUnionNonResident.displayName = 'Persons Non resident Civil Union page component';

export default PersonsPageCivilUnionNonResident;
